/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PresignedURL } from '../models/PresignedURL';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FilesService {
    /**
     * @param fileId
     * @param inspect When true, process the XLSX if needed and return a signed URL. When false or omitted, only poll for existing processed output.
     * @returns PresignedURL
     * @throws ApiError
     */
    public static apiFilesProcessedRead(
        fileId: string,
        inspect: boolean = false,
    ): CancelablePromise<PresignedURL> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/files/{file_id}/processed',
            path: {
                'file_id': fileId,
            },
            query: {
                'inspect': inspect,
            },
        });
    }
}
